import { HeadingThree } from '~/@mid_ui/typography/HeadingThree'
import { NoTransactionsSvg } from './NoTransactionsSvg'

type Props = {
  isIconDisplayed: boolean
}

function NoTransactions({ isIconDisplayed }: Props) {
  if (!isIconDisplayed) {
    return (
      <div className="w-full flex flex-col justify-center">
        Nenašli sa žiadne transakcie.
      </div>
    )
  }

  return (
    <div className="w-full flex flex-col items-center justify-center mt-[40px] lg:mt-[80px]">
      <NoTransactionsSvg className="h-auto" />
      <HeadingThree className="text-center text-2xl mt-[40px]">
        Nenašli sa žiadne transakcie.
      </HeadingThree>
    </div>
  )
}

export { NoTransactions }
